const { parsePhoneNumberFromString } = require('libphonenumber-js/max');

const validatePhoneNumber = (value) => {
  // eslint-disable-next-line no-param-reassign
  value = value.replace(/\s/g, '');
  const phoneNumber = parsePhoneNumberFromString(value, 'AU');
  const test = !!(((phoneNumber && phoneNumber.isValid() && phoneNumber.getType() === 'MOBILE')));
  return test;
};

const validateEmail = (value) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
};

module.exports = {
  validateEmail,
  validatePhoneNumber,
};
